import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import RichTextEditor from '../../../../../../components/HookFormControls/RichTextEditor';
import { PollQuestion } from '../../../../../../db/polls/types';
import { i18nNS } from '../../../../../../i18n';
import useUnpublishedQuestionDescription, { UseUnpublishedQuestionDescription } from './vm';

export interface UnpublishedQuestionDescriptionProps extends UseUnpublishedQuestionDescription {
  pollQuestion: PollQuestion | undefined;
  className?: string;
}

const UnpublishedQuestionDescription = ({
  pollQuestion,
  className,
  ...vmProps
}: UnpublishedQuestionDescriptionProps) => {
  const { t } = useTranslation();

  const { formMethods } = vmProps;
  const { control } = formMethods;
  const { uploadPollAttachmentConfig, handleChange, handleBlur, handleAttachmentsChange } =
    useUnpublishedQuestionDescription(vmProps);

  const initialContentRef = useRef(pollQuestion?.description);
  const initialAttachmentsRef = useRef(pollQuestion?.attachments);

  return (
    <RichTextEditor
      className={className}
      control={control}
      inputField={{
        name: 'description',
        initialValue: initialContentRef.current ?? '',
      }}
      attachments={{
        name: 'attachments',
        initialValue: initialAttachmentsRef.current ?? [],
        uploadRequestConfig: uploadPollAttachmentConfig,
      }}
      onChange={handleChange}
      onBlur={handleBlur}
      onAttachmentsChange={handleAttachmentsChange}
      placeholder={t('enter_your_question_text_here', { ns: i18nNS.POLL })}
    />
  );
};

export default UnpublishedQuestionDescription;
